/**
 * Classe para componetizar o treeview para o sistema.
 *
 * @author Adalto Junior Date: 20/02/2013
 *
 */


Greenmile.Treeview = function (selector) {

    this.selector = selector;

    this.plugin = [
        'json_data',
        'crrm',
        'ui'
    ];

    this.theme = {
        "theme": "classic",
        "dots": false,
        "icons": true
    };

    this.setTheme = function (theme) {

        this.theme = theme;

    };

    this.createTreeView = function (nodes, plugins) {

        this.nodes = nodes;

        if (typeof (plugins) !== "undefined" && plugins.length > 0) {

            this.plugin = plugins;

        }

        $(this.selector).jstree({
            "json_data": {
                "data": this.nodes
            },
            "plugins": this.plugin
        });
    };

    /**
     * Métoto que adicionas nós aos itens do treeview.
     *
     * @param nodeSelector:
     *            seletor html onde será adicionado um novo nó.
     * @param childPosition:
     *            posição do filho atual: "before", "after", "inside", "first",
     *            "last", ou número;
     * @param nodeData:
     *            objeto contendo od dados para o nó recém criado.
     * @param callback:
     *            função a ser executada após a criação do nó.
     * @param skipRename:
     *            boolean que habilita ou não renomear o nó.
     */

    this.addNodeToTreeview = function (nodeSelector, childPosition, nodeData, callback, skipRename) {

        $(this.selector).jstree("create", nodeSelector, childPosition,
            nodeData, callback, skipRename);

    };

    /**
     * Método que executa algum evento para o item selecionado, para isso o item
     * precisa conter o attributo action.
     *
     */

    this.eventListenerSelectNode = function () {

        $(this.selector)
            .on(
            "select_node.jstree",
            function (event, data) {

                try {

                    var action = data.rslt.obj.attr("action");

                    if (typeof (action) !== "undefined" && action !== "") {
                        eval(data.rslt.obj.attr("action"));
                    }

                } catch (e) {

                    var error = new Greenmile.Exception.ReturnError(
                        this,
                        "Problema at execute action to item of treeview.");
                    error.console();

                }
            });

    };

};